export default "__VITE_ASSET__JVywDDEf__"